import { o_global } from "../../common/namespaces";
import { GlobalStorage, globalStorage } from "./storage";

/*                                              */
o_global.Storage ||= GlobalStorage;
o_global.globalStorage ||= globalStorage;
